import { SET_CAR_BOOKING_PROGRESS } from "../actions/car-booking";

export const initialCarBookingStates = {
  carBookingProgress: {
    steps: []
  }
};
export const carBookingReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_CAR_BOOKING_PROGRESS:
      return {
        ...state,
        carBookingProgress: payload
      };
    default:
      break;
  }
};
